// Function to reorder elements: Start from index 2 and move the first part to the end
function reorderImages(carouselId) {
  let container = document.getElementById(carouselId);
  let images = Array.from(container.children); // Get all child divs of the container
  let startIndex = 1; // Define the start index (0-based)
  let newOrder = [...images.slice(startIndex), ...images.slice(0, startIndex)];

  // Clear the container and append the elements in the new order
  container.innerHTML = "";
  newOrder.forEach((image) => {
    container.appendChild(image);
  });

  // Update the images array for subsequent operations
  images = newOrder;

  let buttonId = carouselId.match(/(\d+)/);
  moveImageToLeft(buttonId[0]);
  moveImageToRight(buttonId[0]);

  console.log(`loaded for ${carouselId}`);
}

function moveImageToLeft(buttonId) {
  // Function for right arrow click (shift order to the left)
  document
    .getElementById(`left-arrow-${buttonId}`)
    .addEventListener("click", function () {
      // Rotate the order: move the last element to the front
      let containerChanges = document.getElementById(`carousel-${buttonId}`);
      let imagesChanges = Array.from(containerChanges.children);
      imagesChanges.unshift(imagesChanges.pop());
      containerChanges.innerHTML = "";
      imagesChanges.forEach((image) => {
        containerChanges.appendChild(image);
      });
    });
}

function moveImageToRight(buttonId) {
  // Function for right arrow click (shift order to the right)
  document
    .getElementById(`right-arrow-${buttonId}`)
    .addEventListener("click", function () {
      // Rotate the order: move the first element to the end
      let containerChanges = document.getElementById(`carousel-${buttonId}`);
      let imagesChanges = Array.from(containerChanges.children);
      imagesChanges.push(imagesChanges.shift());
      containerChanges.innerHTML = "";
      imagesChanges.forEach((image) => {
        containerChanges.appendChild(image);
      });
    });
}

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(function () {
    let list = document.getElementsByClassName("carousel-for-product");
    Object.values(list).forEach((e) => reorderImages(e.attributes.id.value));
  }, 0);
});

// // Function for left arrow click (shift order to the left)
// document
//   .getElementById("left-arrow-{{ card_product.id }}")
//   .addEventListener("click", function () {
//     // Rotate the order: move the last element to the front
//     let containerChanges = document.getElementById(
//       "carousel-{{ card_product.id }}"
//     );
//     let imagesChanges = Array.from(containerChanges.children);
//     imagesChanges.unshift(imagesChanges.pop());
//     containerChanges.innerHTML = "";
//     imagesChanges.forEach((image) => {
//       containerChanges.appendChild(image);
//     });
//   });
